import React, { useState } from 'react'
import { Box, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'
import Popover from '../PopoverCustom'
import _ from 'lodash'

const fontFamilyType = 'var(--font-family)'
const colorPopupLabel = '#6A6A6A'

const Text = styled('div')(() => ({
  fontFamily: fontFamilyType,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '12px',
  textAlign: 'center',
  paddingBottom: '3px',
  color: colorPopupLabel,
}))

const ChipCustom = styled(Chip)({
  width: '100%',
  fontFamily: fontFamilyType,
  fontSize: '12px',
  backgroundColor: 'rgba(193, 248, 171, 0.8)',
  py: 0,
  height: '22px',
  color: 'black',
})

const propsChip = (id, isTrue, onMouseEnter, onMouseLeave, label) => ({
  'aria-owns': isTrue ? id : undefined,
  'aria-haspopup': 'true',
  size: 'small',
  onMouseEnter,
  onMouseLeave,
  label,
})

const propsPop = (id, open, anchorEl, onClose, text) => ({
  id,
  open,
  anchorEl,
  onClose,
  text,
})

const boxInside = ({ id, open, state, handle, label, value, description }) => (
  <Box gridColumn="span 1" sx={{ textAlign: 'center' }} key={id}>
    <Text sx={{ pt: 0.5 }}>{label}</Text>
    <ChipCustom {...propsChip(id, open, handle.open, handle.close, value)} />
    <Popover {...propsPop(id, open, state, handle.close, description)} />
  </Box>
)

const ContainerPopover = ({ attributes = [] }) => {
  const [dapHover, setDapHover] = useState(null)
  const [htHover, setHtHover] = useState(null)
  const [copaNSHover, SetCopaNSHover] = useState(null)

  const HANDLE = {
    DAP: {
      stateBoolean: Boolean(dapHover),
      description: 'DAP',
      stateHover: dapHover,
      open: event => setDapHover(event.currentTarget),
      close: () => setDapHover(null),
    },
    HT: {
      stateBoolean: Boolean(htHover),
      description: 'HT',
      stateHover: htHover,
      open: event => setHtHover(event.currentTarget),
      close: () => setHtHover(null),
    },
    COPANS: {
      stateBoolean: Boolean(copaNSHover),
      stateHover: copaNSHover,
      description: 'COPA',
      open: event => SetCopaNSHover(event.currentTarget),
      close: () => SetCopaNSHover(null),
    },
  }

  let data = []
  const keysAttributes = ['dap', 'ht', 'copaNS']
  let averageSizeCopa = 0

  attributes.forEach(obj => {
    if (!Boolean(obj.value)) return
    if (_.includes(['copaNS', 'copaEW'], obj.metaFeature.key))
      averageSizeCopa = averageSizeCopa + parseFloat(obj.value)
  })

  averageSizeCopa /= 2
  keysAttributes.forEach(key => {
    attributes.forEach(obj => {
      if (key !== obj.metaFeature.key) return
      const _handle = HANDLE[`${_.toUpper(key)}`]
      const upperLabel = key === 'copaNS' ? 'Tam. de copa' : obj.metaFeature.nombre
      const value = key === 'copaNS' ? averageSizeCopa : obj.value

      data.push({
        id: obj.metaFeature.key,
        open: _handle.stateBoolean,
        state: _handle.stateHover,
        handle: _handle,
        label: `${upperLabel}`,
        value: `${value} ${obj.metaFeature.u_medida}`,
        description: HANDLE[`${_.toUpper(key)}`].description,
      })
    })
  })

  return (
    <Box spacing={3} sx={{ py: 0, paddingBottom: '6px' }}>
      <Box display="grid" gridTemplateColumns="repeat(3, 3fr)" gap={'6px'}>
        {data.map(obj => boxInside(obj))}
      </Box>
    </Box>
  )
}
export default ContainerPopover
